/**
 * Initialize diffent component resources
 */

import * as registry from "@qpr/client-api-registry";

import icon1 from "../mockIcons/1.svg";
import AllKPIGraphIcon2 from "assets/AllKPIGraphIcon";
import LandingPageBackground from "assets/QPRLogo.png";
import { ReactComponent as MobileIconOutlined } from "assets/MobileIconOutlined.svg";
/**
 * Search results
 *
 * Usage: registry.get('emptyMultiDonutChart)
 */
registry.add({
  searchResultsIconSVG: icon1,
  LandingPageBackground,
});

registry.addSvgIcon({
  AllKPIGraphIcon: AllKPIGraphIcon2,
});

registry.addSvg({
  MobileIconOutlined,
});
